module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0038.png.0606d57c.jpg";